import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { setProjectOrderLink } from '../features/projects/ducks';
import { addToast } from '~features/toast/ducks';
import { postOrderFormless } from '~services/api.helpers';
import { completeOrder, newOrder } from '../forms/ducks';

export function useOnSubmit() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Handle miniproject stuff
  const projectOrderLink = useSelector(
    state => state.projects.projectOrderLink
  );

  const handleRedirection = async (order, formik) => {
    if (projectOrderLink) {
      const { projectId, taskId, formId } = projectOrderLink;

      // If there's a form mismatch, skip linking
      if (projectId && taskId && formId === order.formId) {
        await modifyProjectTask(projectId, taskId, {
          orderId: order.id,
          id: taskId,
        });
        navigate(`/projektit/${projectId}`);
      }
    } else if (formik) {
      navigate('/valmis');
    }

    // Clean up
    if (projectOrderLink) {
      dispatch(setProjectOrderLink(null));
    }
  };

  const onFormSubmit = async ({
    fields,
    setSubmitting,
    formId,
    ancestorOrderId,
  }) => {
    try {
      const orderData = {
        fields,
        formId,
        ancestorOrderId, // For return transports
      };

      const order = await postOrderFormless(orderData);

      dispatch(completeOrder(order));
      dispatch(newOrder());
      setSubmitting(false);

      await handleRedirection(order, navigate, true);

      dispatch(
        addToast({
          message: 'Tilaus tehty onnistuneesti',
          type: 'SUCCESS',
        })
      );
    } catch (e) {
      console.error('Error in onFormSubmit', e);
      setSubmitting(false);
      dispatch(
        addToast({
          message: 'Tilausta tehdessä tapahtui virhe',
          type: 'ERROR',
        })
      );
    }
  };

  return onFormSubmit;
}
